import CmsContentViewPage from './cms-content-view'

export default CmsContentViewPage
